import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-neutral-100" }
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = { class: "flex flex-col justify-center max-w-lg min-h-[calc(100vh-250px)] mx-auto text-center" }
const _hoisted_4 = {
  class: "text-base flex flex-col items-center justify-center",
  autocomplete: "off"
}
const _hoisted_5 = { class: "mt-8 mb-20 text-center max-w-full h-20 w-[500px] text-neutral-800" }
const _hoisted_6 = { class: "prose max-w-6xl prose-indigo mt-6 mx-auto bg-white p-6 rounded-t shadow" }
const _hoisted_7 = { class: "flex flex-col justify-between md:flex-row" }
const _hoisted_8 = { class: "shrink-0 flex items-center mb-5 text-sm font-medium leading-4" }
const _hoisted_9 = {
  type: "button",
  class: "inline-flex items-center rounded-md border border-[#3a0161] bg-white px-3 py-2 text-[#3a0161] shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
}
const _hoisted_10 = { class: "first-letter:uppercase" }
const _hoisted_11 = { class: "md:grid md:gap-6 md:grid-cols-2" }

import { useRouter } from 'vue-router';
import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';
import DomainSearch from '@/components/DomainSearch.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import Icon from '@/components/micro/IconComponent.vue';
import MetaTags from '@/components/MetaTags.vue';
import { LargeRectangle, MediumRectangle } from '@/common/adSizes';
import AdUnit from '@/components/ads/AdUnit.vue';
import { domainNameToUrlPath } from '@/common/domainName';
import { WebsiteToIpLookup } from '@/common/adSlots';


export default /*@__PURE__*/_defineComponent({
  __name: 'WebsiteToIpLookup',
  setup(__props) {

const router = useRouter();

const platforms: Array<'windows' | 'mac' | 'linux'> = [
  'windows',
  'mac',
  'linux',
];

function redirectTo(domain: string): void {
  router.push(`/domains/${domainNameToUrlPath(domain)}/webservers/`);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: "Website to IP Lookup",
        description: "Find the IP addresses for any website or domain name. This online tool shows both IPv4 and IPv6 addresses as well as their hosting provider and location.",
        url: `https://www.nslookup.io/website-to-ip-lookup/`
      })
    ])),
    _createVNode(HeaderComponent, {
      "domain-search-to-url": (encodedDomain) => `/domains/${encodedDomain}/webservers/`,
      "search-button-text": "Find IP addresses"
    }, null, 8, ["domain-search-to-url"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("main", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "font-extrabold text-4xl max-w-full my-8" }, "Website to IP lookup", -1)),
            _createVNode(DomainSearch, {
              class: "h-12 mb-6 max-w-full w-[500px]",
              autofocus: "",
              emphasize: "",
              buttonText: "Find IP addresses",
              "placeholder-text": "URL or domain name",
              onSubmitted: redirectTo
            }),
            _createElementVNode("p", _hoisted_5, [
              _cache[0] || (_cache[0] = _createTextVNode("Find all IP addresses with this website to IP checker. For example, try ", -1)),
              _createVNode(DnsRecordsLink, {
                page: "webservers",
                domain: "facebook.com",
                class: "text-blue-600 hover:text-blue-800 hover:underline"
              }),
              _cache[1] || (_cache[1] = _createTextVNode(" or ", -1)),
              _createVNode(DnsRecordsLink, {
                page: "webservers",
                domain: "google.com",
                class: "text-blue-600 hover:text-blue-800 hover:underline"
              }),
              _cache[2] || (_cache[2] = _createTextVNode(" to view their IP addresses. You can also enter a URL to get its IP addresses. ", -1))
            ]),
            _createVNode(AdUnit, {
              class: "mt-8 mx-auto",
              config: _unref(WebsiteToIpLookup)
            }, null, 8, ["config"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "inline-block text-2xl mt-0" }, "How to lookup a website's IP address", -1)),
            _createElementVNode("span", _hoisted_8, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "hidden mr-2 sm:inline" }, "Jump to", -1)),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(platforms, (platform) => {
                return _createVNode(_component_router_link, {
                  key: platform,
                  to: `#${platform.toLowerCase()}`,
                  class: "no-underline mr-2 last:mr-0"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", _hoisted_9, [
                      _createVNode(Icon, {
                        icon: platform,
                        class: "mr-2"
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(platform), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"])
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _cache[11] || (_cache[11] = _createElementVNode("p", null, [
                _createTextVNode("Every website has at least one IP address connected to its domain name. For example, the website Facebook has, among others, the IP address "),
                _createElementVNode("code", null, "157.240.214.35"),
                _createTextVNode(" connected to the domain name "),
                _createElementVNode("code", null, "www.facebook.com"),
                _createTextVNode(".")
              ], -1)),
              _cache[12] || (_cache[12] = _createElementVNode("p", null, "When you enter a URL in your browser, it will first determine the domain name of that URL. It then looks up the IP address and connects to the server with this IP. Once connected, it fetches the website's source code to display the page.", -1)),
              _createElementVNode("p", null, [
                _cache[8] || (_cache[8] = _createTextVNode("These IP addresses are configured in the Domain Name System (DNS) as ", -1)),
                _createVNode(_component_router_link, { to: "/learning/dns-record-types/a/" }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("A", -1)
                  ]))]),
                  _: 1
                }),
                _cache[9] || (_cache[9] = _createTextVNode(" and ", -1)),
                _createVNode(_component_router_link, { to: "/learning/dns-record-types/aaaa/" }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("AAAA", -1)
                  ]))]),
                  _: 1
                }),
                _cache[10] || (_cache[10] = _createTextVNode(" records. But how can you look up those IP addresses? That depends on the operating system you are using. Windows, Linux and Mac all have a different way of finding the IPv4 and IPv6 addresses. The sections below list the instructions for each operating system.", -1))
              ])
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("img", {
              class: "w-full md:mb-0 md:mt-6",
              src: "img/pages/record-type-lookup/a-lookup-mac.png",
              alt: "Example output of an IPv4 address lookup"
            }, null, -1))
          ]),
          _cache[81] || (_cache[81] = _createElementVNode("h2", { id: "windows" }, "How to lookup a website's IP address on Windows", -1)),
          _cache[82] || (_cache[82] = _createElementVNode("p", null, "To check the server IP addresses for a domain name on Windows, follow these steps:", -1)),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, [
              _cache[18] || (_cache[18] = _createTextVNode("Open a ", -1)),
              _cache[19] || (_cache[19] = _createElementVNode("em", null, "command prompt", -1)),
              _cache[20] || (_cache[20] = _createTextVNode(" by navigating to ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "click" }),
                _cache[14] || (_cache[14] = _createTextVNode(" Start → ", -1)),
                _createVNode(Icon, { icon: "click" }),
                _cache[15] || (_cache[15] = _createTextVNode(" 'Type here to search' → ", -1)),
                _createVNode(Icon, { icon: "type" }),
                _cache[16] || (_cache[16] = _createTextVNode(" 'cmd' → ", -1)),
                _createVNode(Icon, { icon: "click" }),
                _cache[17] || (_cache[17] = _createTextVNode(" Open", -1))
              ]),
              _cache[21] || (_cache[21] = _createTextVNode(".", -1)),
              _cache[22] || (_cache[22] = _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: "img/pages/record-type-lookup/open-command-prompt-windows.png",
                alt: "Open a command prompt in Windows"
              }, null, -1))
            ]),
            _createElementVNode("li", null, [
              _cache[26] || (_cache[26] = _createTextVNode("Type ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[23] || (_cache[23] = _createTextVNode()),
                _cache[24] || (_cache[24] = _createElementVNode("code", null, "nslookup -q=A example.com", -1))
              ]),
              _cache[27] || (_cache[27] = _createTextVNode(" and hit ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[25] || (_cache[25] = _createTextVNode(" [enter]", -1))
              ]),
              _cache[28] || (_cache[28] = _createTextVNode(" to get the IPv4 addresses for ", -1)),
              _cache[29] || (_cache[29] = _createElementVNode("code", null, "example.com", -1)),
              _cache[30] || (_cache[30] = _createTextVNode(".", -1)),
              _cache[31] || (_cache[31] = _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: "img/pages/record-type-lookup/a-lookup-windows.png",
                alt: "IPv4 address lookup in Windows"
              }, null, -1))
            ]),
            _cache[32] || (_cache[32] = _createElementVNode("li", null, [
              _createTextVNode("The IP addresses are listed below the "),
              _createElementVNode("strong", null, "Non-authoritative answer"),
              _createTextVNode(" heading.")
            ], -1)),
            _cache[33] || (_cache[33] = _createElementVNode("li", null, [
              _createTextVNode("(Optional) To also see the IPv6 addresses, repeat these steps with "),
              _createElementVNode("code", null, "AAAA"),
              _createTextVNode(" instead of "),
              _createElementVNode("code", null, "A"),
              _createTextVNode(".")
            ], -1))
          ]),
          _cache[83] || (_cache[83] = _createElementVNode("h2", { id: "mac" }, "How to lookup a website's IP address on Mac OS", -1)),
          _cache[84] || (_cache[84] = _createElementVNode("p", null, "To check the IP addresses for a domain name on a Mac, follow these steps:", -1)),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, [
              _cache[37] || (_cache[37] = _createTextVNode("Open a ", -1)),
              _cache[38] || (_cache[38] = _createElementVNode("em", null, "terminal", -1)),
              _cache[39] || (_cache[39] = _createTextVNode(" by entering ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[34] || (_cache[34] = _createTextVNode(" [command] + [space] → ", -1)),
                _createVNode(Icon, { icon: "type" }),
                _cache[35] || (_cache[35] = _createTextVNode(" 'terminal.app' → ", -1)),
                _createVNode(Icon, { icon: "type" }),
                _cache[36] || (_cache[36] = _createTextVNode(" [enter]", -1))
              ]),
              _cache[40] || (_cache[40] = _createTextVNode(".", -1)),
              _cache[41] || (_cache[41] = _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: "img/pages/record-type-lookup/open-terminal-mac.png",
                alt: "Open a terminal on a Mac"
              }, null, -1))
            ]),
            _createElementVNode("li", null, [
              _cache[45] || (_cache[45] = _createTextVNode("Type ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[42] || (_cache[42] = _createTextVNode()),
                _cache[43] || (_cache[43] = _createElementVNode("code", null, "dig example.com A", -1))
              ]),
              _cache[46] || (_cache[46] = _createTextVNode(" and hit ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[44] || (_cache[44] = _createTextVNode(" [enter]", -1))
              ]),
              _cache[47] || (_cache[47] = _createTextVNode(" to get the IPv4 addresses for ", -1)),
              _cache[48] || (_cache[48] = _createElementVNode("code", null, "example.com", -1)),
              _cache[49] || (_cache[49] = _createTextVNode(".", -1)),
              _cache[50] || (_cache[50] = _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: "img/pages/record-type-lookup/a-lookup-mac.png",
                alt: "IPv4 lookup on a Mac"
              }, null, -1))
            ]),
            _cache[51] || (_cache[51] = _createElementVNode("li", null, [
              _createTextVNode("The IP addresses are listed below the "),
              _createElementVNode("strong", null, "ANSWER SECTION"),
              _createTextVNode(" heading.")
            ], -1)),
            _cache[52] || (_cache[52] = _createElementVNode("li", null, [
              _createTextVNode("(Optional) To also see the IPv6 addresses, repeat these steps with "),
              _createElementVNode("code", null, "AAAA"),
              _createTextVNode(" instead of "),
              _createElementVNode("code", null, "A"),
              _createTextVNode(".")
            ], -1))
          ]),
          _cache[85] || (_cache[85] = _createElementVNode("h2", { id: "linux" }, "How to lookup a website's IP address on Linux", -1)),
          _cache[86] || (_cache[86] = _createElementVNode("p", null, "To check the IP addresses for a domain name on Linux, follow these steps:", -1)),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, [
              _cache[56] || (_cache[56] = _createTextVNode("Open a ", -1)),
              _cache[57] || (_cache[57] = _createElementVNode("em", null, "terminal", -1)),
              _cache[58] || (_cache[58] = _createTextVNode(" by entering ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[53] || (_cache[53] = _createTextVNode(" [Super] → ", -1)),
                _createVNode(Icon, { icon: "type" }),
                _cache[54] || (_cache[54] = _createTextVNode(" 'terminal' → ", -1)),
                _createVNode(Icon, { icon: "type" }),
                _cache[55] || (_cache[55] = _createTextVNode(" [enter]", -1))
              ]),
              _cache[59] || (_cache[59] = _createTextVNode(".", -1)),
              _cache[60] || (_cache[60] = _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: "img/pages/record-type-lookup/open-terminal-linux.png",
                alt: "Open a terminal in Linux"
              }, null, -1))
            ]),
            _createElementVNode("li", null, [
              _cache[64] || (_cache[64] = _createTextVNode("Type ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[61] || (_cache[61] = _createTextVNode()),
                _cache[62] || (_cache[62] = _createElementVNode("code", null, "dig example.com A", -1))
              ]),
              _cache[65] || (_cache[65] = _createTextVNode(" and hit ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[63] || (_cache[63] = _createTextVNode(" [enter]", -1))
              ]),
              _cache[66] || (_cache[66] = _createTextVNode(" to get the IPv4 addresses for ", -1)),
              _cache[67] || (_cache[67] = _createElementVNode("code", null, "example.com", -1)),
              _cache[68] || (_cache[68] = _createTextVNode(".", -1)),
              _cache[69] || (_cache[69] = _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: "img/pages/record-type-lookup/a-lookup-linux.png",
                alt: "IPv4 lookup in Linux"
              }, null, -1))
            ]),
            _cache[70] || (_cache[70] = _createElementVNode("li", null, [
              _createTextVNode("The IP addresses are listed below the "),
              _createElementVNode("strong", null, "ANSWER SECTION"),
              _createTextVNode(" heading.")
            ], -1)),
            _cache[71] || (_cache[71] = _createElementVNode("li", null, [
              _createTextVNode("(Optional) To also see the IPv6 addresses, repeat these steps with "),
              _createElementVNode("code", null, "AAAA"),
              _createTextVNode(" instead of "),
              _createElementVNode("code", null, "A"),
              _createTextVNode(".")
            ], -1))
          ]),
          _cache[87] || (_cache[87] = _createElementVNode("h2", null, "How to find a website's IP address", -1)),
          _cache[88] || (_cache[88] = _createElementVNode("p", null, "To check the IP addresses of a domain, follow these steps:", -1)),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, [
              _cache[73] || (_cache[73] = _createTextVNode("Open the ", -1)),
              _createVNode(_component_router_link, { to: "/website-to-ip-lookup/" }, {
                default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                  _createTextVNode("website to IP lookup tool", -1)
                ]))]),
                _: 1
              }),
              _cache[74] || (_cache[74] = _createTextVNode(".", -1)),
              _cache[75] || (_cache[75] = _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: "img/pages/website-to-ip-lookup/website-to-ip-lookup.png",
                alt: "Open the website to IP lookup tool"
              }, null, -1))
            ]),
            _createElementVNode("li", null, [
              _cache[77] || (_cache[77] = _createTextVNode("Enter the URL or domain name and hit ", -1)),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _cache[76] || (_cache[76] = _createTextVNode(" [enter]", -1))
              ]),
              _cache[78] || (_cache[78] = _createTextVNode(".", -1)),
              _cache[79] || (_cache[79] = _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: "img/pages/website-to-ip-lookup/website-to-ip-lookup-results.png",
                alt: "Example IP addresses"
              }, null, -1))
            ]),
            _cache[80] || (_cache[80] = _createElementVNode("li", null, "The tool will query the IPv4 and IPv6 addresses and shown them at the top of the page.", -1))
          ])
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})